import { useEffect, useRef } from 'react';

export const useOnFormDirtyChange = ({
  onFormDirtyChange,
  dirty,
}: {
  onFormDirtyChange: (isFormDirty: boolean) => void;
  dirty: boolean;
}) => {
  const initialRender = useRef(true);

  useEffect(() => {
    if (onFormDirtyChange && !initialRender.current) {
      onFormDirtyChange(dirty);
    }

    return () => {
      if (onFormDirtyChange && dirty) onFormDirtyChange(false);
    };
  }, [dirty, onFormDirtyChange]);

  useEffect(() => {
    if (initialRender.current === true) {
      initialRender.current = false;
    }
  }, []);
};
